import Vue from 'vue';

import { ModuleRegistry } from '@ag-grid-community/core';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
ModuleRegistry.registerModules([ExcelExportModule]);

window.showPlayerContracts = function (playerPage, playerData, appConstantData) {
  // if the vue does not exist, recreate it
  if (!playerPage.playerContractsVue) {
    playerPage.playerContractsVue = new Vue({
      el: '#player-contracts-vue-container',
      components: {
        'root-component': () => import('./PlayerContracts.vue'),
      },
      render: function (h) {
        return h('root-component', {
          props: {
            playerData: playerData,
            appConstantData: appConstantData,
          },
        });
      },
    });
  }

  // normal DView player method of hiding / showing page content
  var $container = $('.print-statement'),
    $noRemove = $container.find('p.printHeader');

  $container.find('p.printHeader').empty().append('<strong>Player Contracts</strong>');
  $container.html($noRemove);
  $container.append('');

  $('#contentContract').show();
};
